import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

import { CalendarModel, CALENDARVIEW } from '../core/models/calendar.model';
import { MOCK_CALENDAR, MOCK_SCHEDULE_TODAY } from '../core/constants/calendar';
import { WindowScrollService } from '../core/services/window-scroll.service';

@Component({
  selector: 'app-broker-calendar',
  templateUrl: './broker-calendar.component.html',
  styleUrls: ['./broker-calendar.component.scss']
})
export class BrokerCalendarComponent implements OnInit {

  public filterForm: FormGroup;

  public showColumnCalendar = true;

  mockCalendar: CalendarModel = MOCK_CALENDAR;
  mockTodaySchedule: any = MOCK_SCHEDULE_TODAY;

  activeYear: number;
  activeMonth: number;
  activeDay: number;

  markData: any;
  showMarkModal = false;
  public openEvent = false;
  public isSearch = false;
  public dataMark = {
    day: null,
    month: null
  };
  public showFilter = false;
  public alertFilter = false;

  calendarViewMode = CALENDARVIEW.Month;

  constructor(private scroll: WindowScrollService,
              private fb: FormBuilder,
              private router: Router) { }

  ngOnInit(): void {
    this.initializeForm();
    this.mockCalendar.today.day = new Date().getDate();
    this.mockCalendar.today.month = new Date().getMonth();
    this.mockCalendar.today.year = new Date().getFullYear();
    this.activeDay = this.mockCalendar.today.day;
    this.activeMonth = this.mockCalendar.today.month;
    this.activeYear = this.mockCalendar.today.year;
  }

  private initializeForm(): void {
    this.filterForm = this.fb.group({
      key_event: [null],
      date_from: [null],
      date_to: [null],
      event: [null],
      task: [null],
      remember: [null],
      return: [null],
      visit: [null]
    });
  }

  public openCalendar(data: boolean) {
    this.showColumnCalendar = data;
    if (data) {
      this.scroll.disable();
    } else {
      this.scroll.enable();
    }
  }

  public selectViewMode(mode: CALENDARVIEW) {
    this.calendarViewMode = mode;
  }

  public clickCalendar(data) {
    console.log('BrokerCalendarComponent -> clickCalendar -> data', data);
  }

  public clickGear(data) {
    console.log('BrokerCalendarComponent -> clickGear -> data', data);
  }

  public clickBack(data) {
    if (data < 0) {
      return;
    }
    if (this.activeMonth === 0) {
      this.activeMonth = 12;
      this.activeYear--;
    }
    this.activeMonth--;
  }

  public clickNext(data) {
    if (data > 11) {
      return;
    }
    if (this.activeMonth === 11) {
      this.activeMonth = 0;
      this.activeYear++;
    }
    this.activeMonth++;
  }

  selectDate(data: any): void {
    this.activeYear = data.year;
    this.activeMonth = data.month;
    this.activeDay = data.day;
  }

  public openMarkModal(markData: any): void {
    this.markData = markData;
    this.showMarkModal = true;
    this.scroll.disable();
  }

  public openNewMarkModal(data: {day: number, month: number}): void {
    this.openModalMark(data);
    this.scroll.disable();
  }

  goToday(): void {
    this.activeDay = this.mockCalendar.today.day;
    this.activeMonth = this.mockCalendar.today.month;
    this.activeYear = this.mockCalendar.today.year;
  }

  closeMarkModal(): void {
    this.scroll.enable();
    this.showMarkModal = false;
  }

  public openModalMark(data: {day: number, month: number}): void {
    this.dataMark = data;
    this.openEvent = true;
  }

  public getFilter(event: boolean): void {
    this.scroll.disable();
    this.showFilter = event;
  }

  public getCloseFilter(data: boolean): void {
    this.showFilter = data;
  }

  public clearForm(): void {
    this.isSearch = false;
    this.alertFilter = false;
    this.router.navigate(['/agenda']);
    this.filterForm.reset();
    this.calendarViewMode = CALENDARVIEW.Month;
  }

  public applyFilter(): void {
    const queryData = this.validatorFilter();
    this.router.navigate(['/agenda'], { queryParams: queryData });
    if (Object.keys(queryData).length === 0 && queryData.constructor === Object) {
      if (this.calendarViewMode === CALENDARVIEW.Results) {
        this.calendarViewMode = CALENDARVIEW.Month;
      }
    } else {
      this.calendarViewMode = CALENDARVIEW.Results;
    }
  }

  public validatorFilter(): any {
    const data = {
      palavra_chave: this.filterForm.get('key_event').value,
      data_visita_de: this.filterForm.get('date_from').value,
      data_visita_ate: this.filterForm.get('date_to').value,
      evento: this.filterForm.get('event').value,
      tarefa: this.filterForm.get('task').value,
      lembrete: this.filterForm.get('remember').value,
      retorno: this.filterForm.get('return').value,
      visita: this.filterForm.get('visit').value,
    };
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        if (data[key] === null || !data[key]) {
          delete data[key];
        }
      }
    }
    return data;
  }
}
